import React, { useCallback, SyntheticEvent } from 'react';
import { useDispatch } from 'react-redux';

import { xcriticalFormReset } from '@xcritical/forms';

import { ActionsButtons } from '@crm-framework/actions-buttons';
import { registryActions } from '@crm-framework/registry';

import { IPromoFormActionsProps } from '../types';
import { promoActions } from '../actions';
import { isNewPromo } from '../utils';
import { PROMO_FORM_NAME, PROMO_REGISTRIES } from '../consts';

export const PromoFormActions = ({ id, disabled }: IPromoFormActionsProps) => {
  const dispatch = useDispatch();

  const handleSavePromo = useCallback(
    (e: SyntheticEvent) => {
      e.preventDefault();
      dispatch(promoActions.save({ id }));
    },
    [id]
  );

  const handleRevertPromo = useCallback(
    (e: SyntheticEvent) => {
      e.preventDefault();
      dispatch(xcriticalFormReset(PROMO_FORM_NAME));
      dispatch(registryActions.set(PROMO_REGISTRIES.IS_RESET_FORM, true));
    },
    [id]
  );

  return (
    <ActionsButtons
      buttons={[
        {
          title: 'Revert',
          type: 'button',
          appearance: 'link',
          onClick: handleRevertPromo,
          disabled,
        },
        {
          title: isNewPromo(id) ? 'Save' : 'Update',
          type: 'button',
          appearance: 'primary',
          onClick: handleSavePromo,
          disabled,
        },
      ]}
    />
  );
};
